import { render, staticRenderFns } from "./LahanUmumMonitoringDuaDetail.vue?vue&type=template&id=519c854a"
import script from "./LahanUmumMonitoringDuaDetail.vue?vue&type=script&lang=js"
export * from "./LahanUmumMonitoringDuaDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports